import { approvedFinanceReportApi } from "helpers/backend_helper"
import { serializeQuery } from "helpers/service_helper"

export const approved = async(financeReportId, openNotification)=>{
    const params = serializeQuery({financeReportId})
    try {
    await approvedFinanceReportApi(params)
    openNotification("success", "top", "تغییرات انجام شد")
    } catch (error) {
        openNotification("error", "top", error?.message)
    }
}